module.exports = __webpack_public_path__ + "static/media/awards-4.3e552409.png";